/* eslint-disable react/prop-types, no-shadow */

import React from 'react'
// eslint-disable-next-line
import FolderContent from './FolderContent'

const ContentPanel = ({ contentId, isViewOnly, selectedFolder }) => {
  return (
    <div className="contentPanel">
      {selectedFolder ? (
        <FolderContent
          contentId={contentId}
          folder={selectedFolder}
          isViewOnly={isViewOnly}
        />
      ) : (
        <div />
      )}
    </div>
  )
}

export default ContentPanel
